// extracted by mini-css-extract-plugin
export var table = "_wu-0";